if (!customElements.get('cart-item-subscribe-toggle')) {
  customElements.define(
    'cart-item-subscribe-toggle',
    class CartItemSubscribeToggle extends HTMLElement {
      connectedCallback() {
        this.lineKey = this.dataset.lineKey;
        this.quantity = this.dataset.quantity;

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
      }

      handleClick(event) {
        const subscribeButton = event.target.closest('[data-role="subscribe"]');
        if (subscribeButton) {
          this.updateLine(subscribeButton.dataset.sellingPlanId);
          return;
        }

        const unsubscribeButton = event.target.closest('[data-role="unsubscribe"]');
        if (unsubscribeButton) {
          this.updateLine(null);
        }
      }

      handleChange(event) {
        if (event.target.dataset.role !== 'frequency') return;
        this.updateLine(event.target.value);
      }

      updateLine(sellingPlan) {
        this.classList.add('cart-item__subscribe--loading');

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          id: this.lineKey,
          quantity: parseInt(this.quantity, 10),
          selling_plan: sellingPlan,
          sections: sectionsToBundle,
        });

        fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            // /cart/change.js returns { status, message, description, errors }
            // instead of a cart object on failure. CartItems.onCartUpdate has no
            // onCartError handler defined, so publishing an error shape as-is
            // crashes it - surface the error locally instead.
            if (parsedState.status || parsedState.errors) {
              console.error(parsedState.description || parsedState.message || parsedState.errors);
              return;
            }
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.classList.remove('cart-item__subscribe--loading');
          });
      }
    }
  );
}
